<template>
  <ContainerScrolling class="AboutInformation">
    <LayoutFill :no-gutters="!bannerGutter" :no-padding="!bannerGutter">
      <MainBanner :title="pageTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <SubNavigationTabs
        id="aboutInformation"
        v-slot="{ activeTab }"
        :page-title="pageTitle"
        :page-mapping="pageMapping"
        :centered-tabs="centeredTabs"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :id="`tab-${index}`"
          :key="index"
          :aria-controls="`panel-${index}`"
          :tabindex="activeTab !== index ? -1 : 0"
          >{{ tab.title }}</v-tab
        >
        <v-tab-item v-for="(tab, index) in tabs" :key="index">
          <v-card flat>
            <div
              :id="`panel-${index}`"
              role="tabpanel"
              :aria-labelledby="`tab-${index}`"
              :hidden="activeTab !== index"
            >
              <LegalTerms :term="tab.term" />
            </div>
          </v-card>
        </v-tab-item>
      </SubNavigationTabs>
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import {
  displayIsMobile,
  displayIsTablet,
  displayIsDesktop,
} from "~/components/utilities/displayBreakpoints";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";
import SubNavigationTabs from "~/components/navigation/SubNavigationTabs";

import MainBanner from "~/components/banner/MainBanner";

import LegalTerms from "~/components/page/components/terms/LegalTerms";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "AboutInformation",
  components: {
    LegalTerms,
    ContainerScrolling,
    LayoutGutters,
    LayoutFill,
    MainBanner,
    SubNavigationTabs,
  },
  middleware: ["ensureUserLoaded"],
  data() {
    return {
      pageTitle: "About",
    };
  },
  head() {
    const { siteName, domain } = this;

    const pageTitle = "About Information | " + getPageTitle(siteName);

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Information and policies for using ${siteName}, providing early research outputs in ${domain}.`,
        },
      ],
    };
  },
  computed: {
    displayIsMobile,
    displayIsTablet,
    displayIsDesktop,
    ...mapState({
      tabs: (state) => state.theme.pages.about,
      partnerName: (state) => state.theme.id.toUpperCase(),
      domain: (state) => state.theme.domain,
      siteName: (state) => getSiteName(state.theme),
      pageMapping: (state) => state.theme.pages.about.map((tab) => tab.pageMap),
      layout: (state) => state.theme.layout,
    }),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    bannerGutter() {
      return this.layout.staticBannerGuttering;
    },
    centeredTabs() {
      return this.layout.infoPageTabsCentered;
    },
  },
  watchQuery: ["show"],
};
</script>
